module.exports = __webpack_public_path__ + "img/ContactInfo.d691c8d9.svg";